import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "./ui/card";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import yogivityProgramImage from "../assets/yoga1.jpg";
import nutritionImage from "../assets/broccoli.jpg";
import exampleImage2 from "../assets/yoga2.jpg";

const services = [
  {
    title: "YOGIVITY Program",
    duration: "6 hét",
    subtitle: "Mély átalakulási folyamat",
    description:
      "Egy komplex, hosszú élettartamot és jóllétet célzó program, amely ötvözi az ősi jóga bölcsességét a modern egészségtudománnyal. Átalakítsd át a testedet, az elmédet és az életmódodat strukturált heti, személyreszabott foglalkozásokon keresztül.",
    image: yogivityProgramImage,
    features: [
      "Megérted a longevity alapjait",
      "4 jóga és 3 erősítő videót, 1 relaxációs és 2 légzéstechnika hanganyagot megkapsz ajándékba",
      "Stresszkezelés és csökkentés elsajátítása + 1 relaxációs hanganyag a stresszes helyzetekre",
      "Személyre szabott étkezési tanácsadás + 7 napos személyre szabott étrend",
      "Személyes online videókonzultációk hetente",
    ],
    badge: "Legnépszerűbb",
  },
  {
    title: "Étkezési Tanácsadás",
    duration: null,
    subtitle: "Személyreszabott, kiegyensúlyozott, élvezetes",
    description:
      "Lehet, hogy testsúlyodat csökkenteni, növelni vagy szinten tartani szeretnéd. Lehet, hogy nem is érdekel, mennyi a súlyod, számodra inkább az egészségesebb étkezés elsajátítása a fontos. Vagy talán gyakran azon kapod magad, hogy nem tudod, mikor, mennyit és mit kellene enned, és ez bizonytalanságot okoz benned. A tanácsadásom alatt megtanítom neked, mire van valójában szüksége a testednek, hogy utána már ne függj az étkezési trendektől és a bizonytalanságtól.",
    image: nutritionImage,
    features: [
      "Első kapcsolatfelvétel → rövid egyeztetés, célok tisztázása",
      "Állapotfelmérő kérdőív és 3 napos étkezési napló kitöltése",
      "Személyes konzultáció (általában 60–90 perc)",
      "Személyre szabott javaslatok az étrend, étkezési ritmus, szokások kapcsán",
      "Mintaétkezési terv, ételcsere-tippek",
    ],
    badge: null,
  },
  {
    title: "Jógázz Online",
    duration: "Korlátlan videó hozzáférés",
    subtitle: "Rövidebb, hosszabb, könnyebb, igénybevevőbb órák",
    description:
      "A mozgásnak nem kell hosszúnak vagy túl megterhelőnek lennie, nem kell sokat utaznod, és nem kell, hogy mindez sokba kerüljön. Itt rendszeresen gyakorolhatsz — akkor, ott és olyan kényelmes ruhában, ami számodra épp megfelelő. Ha van kívánságod az online órák kapcsán, írd meg nekem, és rajta leszek, hogy megvalósítsam.",
    image: exampleImage2,
    features: [
      "Jógaórák",
      "Meditációk",
      "Légzőgyakorlatok",
      "Könnyű súlyzós gyakorlatok",
      "Folyamatosan bővülő videók",
    ],
    badge: "Top ár-érték",
    bottomBadge: "Hamarosan elérhető",
  },
];

export function Services() {
  return (
    <section id="services" className="py-24 bg-secondary/50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl mb-4">Szolgáltatásaim</h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Válaszd ki azt az utat, amelyik leginkább megfelel most a számodra.
            Minden szolgáltatásom úgy lett kialakítva, hogy támogassa egyedi
            céljaidat és életmódodat.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card
              id={service.title === "YOGIVITY Program" ? "yogivity-program" : service.title === "Étkezési Tanácsadás" ? "etkezes-tanacsadas" : service.title === "Jógázz Online" ? "jogazz-online" : undefined}
              key={index}
              className="group hover:shadow-xl transition-all duration-300 relative overflow-hidden bg-white border-2 hover:border-primary/20 flex flex-col h-full"
            >
              {service.badge && (
                <Badge className="absolute top-4 right-4 z-10 bg-primary text-primary-foreground">
                  {service.badge}
                </Badge>
              )}

              {service.bottomBadge && (
                <Badge className="absolute top-4 left-4 z-10 bg-orange-300/80 text-black-foreground">
                  {service.bottomBadge}
                </Badge>
              )}

              <div className="aspect-[4/3] overflow-hidden bg-secondary/20">
                <img
                  src={service.image}
                  alt={service.title}
                  className={`w-full h-full group-hover:scale-105 transition-transform duration-500 ${
                    index === 0
                      ? "object-cover object-center scale-140"
                      : "object-cover"
                  }`}
                />
              </div>

              <CardHeader className="space-y-3 flex-grow">
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <CardTitle className="text-2xl text-foreground">
                      {service.title}
                    </CardTitle>
                    {service.duration && (
                      <span className="text-sm text-primary bg-primary/10 px-3 py-1 rounded-full text-center whitespace-nowrap">
                        {service.duration}
                      </span>
                    )}
                  </div>
                  <p className="text-lg text-primary">{service.subtitle}</p>
                </div>

                <CardDescription className="text-base text-muted-foreground leading-relaxed">
                  {service.description}
                </CardDescription>
              </CardHeader>

              <CardContent className="space-y-6 mt-auto">
                <div className="space-y-3">
                  <h4 className="text-sm uppercase tracking-wide text-primary">
                    MIT TARTALMAZ?
                  </h4>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li
                        key={idx}
                        className="flex items-start text-sm text-muted-foreground"
                      >
                        <div className="w-1.5 h-1.5 bg-primary rounded-full mr-3 mt-2 flex-shrink-0"></div>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="border-t border-border pt-6">
                  <Button
                    className="w-full bg-primary 
                text-primary-foreground
                hover:bg-[#6d5a44]          /* Darker shade on hover */
                active:bg-[#5a4a38]         /* Even darker when clicked */
                transition-colors 
                duration-200
                transform 
                hover:scale-[1.02]          /* Subtle grow effect */
                active:scale-[0.98]         /* Subtle press effect */
                shadow-md 
                hover:shadow-lg             /* Enhanced shadow on hover */
                hover:shadow-primary/30     /* Colored glow */
                border 
                border-primary/20           /* Subtle border */
                hover:border-primary/40 text-primary-foreground"
                  >
                    Tudj meg többet
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-16 text-center" id="book-appointment">
          <div className="bg-white rounded-2xl p-8 max-w-2xl mx-auto border border-border">
            <h3 className="text-2xl mb-4 text-foreground">
              Nem vagy biztos benne, melyik szolgáltatás a megfelelő számodra?
            </h3>
            <p className="text-muted-foreground mb-6">
              Foglalj egy 15 perces ingyenes konzultációt, hogy megbeszéljük a
              céljaidat, és megtaláljuk számodra a megoldást.
            </p>
            <Button
              variant="outline"
              size="lg"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground"
              onClick={() => window.open('https://calendly.com/dorottyaberekvolgyi/30min', '_blank')}
              >
              Időpontot foglalok
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}